'use client';

import { ReactNode } from 'react';

import { SendEventOptions } from '../types';
import { useUserEventLogger } from '../use-tracking-hooks';

/**
 * 페이지 이름을 설정하고 페이지 뷰 이벤트를 전송하는 컴포넌트
 * @description pageViewEvent가 주어지지 않으면 pageName을 이벤트 이름으로 사용
 * @param children
 * @param pageName
 * @param pageViewEvent
 * @param eventProperty
 * @param eventOption
 * @constructor
 */
export const PageViewEventLogger = ({
  children,
  pageName,
  eventName,
  eventProperty,
  eventOption
}: {
  children?: ReactNode;
  pageName: string;
  eventName?: string;
  eventProperty?: Record<string, unknown>;
  eventOption?: SendEventOptions;
}) => {
  const { sendViewEvent, pageName: savedPageName } = useUserEventLogger(pageName);

  if (pageName === savedPageName) {
    sendViewEvent(eventName ?? pageName, eventProperty, eventOption);
  }

  return <>{children}</>;
};
